import React, { useState } from 'react';
// import { GoogleGenerativeAI } from '@google/generative-ai';
import axios from "axios"
import Markdownkatexnew from "./Markdown.js";
// import { Ollama } from 'ollama'
// import ollama from 'ollama';
// import { useState } from 'react';

const GeminiChat = ({ tittle, type }) => {
  const [prompt, setPrompt] = useState(tittle);
  const [model, setModel] = useState('gemini-3.5-flash');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);
  // gemini-2.5-flash
  // gemini-3.1-flash-lite
  // gemini-3.1-pro-preview
  // gemini-3.1-flash-lite
  // https://developer.puter.com/tutorials/free-gemini-api/#example-6-image-analysis

  // Inicializa la API con tu clave
  // const apiKey = process.env.REACT_APP_GEMINI_API_KEY; // Reemplaza con tu clave o variable de entorno
  // const ai = new GoogleGenerativeAI({ apiKey: apiKey });


  const generarContenido = async () => {
    if (!prompt) return;
    setLoading(true);
    setResponse('');


    // const { Ollama } = await import('ollama');
    // const ollama = new Ollama();


    // const ollamaRes = await fetch('http://www.esfapa.edu.pe:11434/api/generate', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({
    //     model: 'llama3',
    //     messages: prompt,
    //     stream: false,
    //   }),
    // });
    // const data = await ollamaRes.json();
    // // res.json({ message: data.message.content });
    // console.log(data, "ai")


    await axios.post(`${process.env.REACT_APP_API_URL}/users/userCr`, { prompt, model })
      .then((res) => {
        setResponse(res.data.response)
        console.log(res.data.response, "ai")
        setLoading(false);
      })
      .catch((err) => {
        // toast.error(err);
        // if (err.response.status === 401) {
        // }
      })


  };

  return (
    <div className=''>
      {/*<input className="form-control" type="text" value={prompt} onChange={(e) => setPrompt(e.target.value)} placeholder="Escribe tu mensaje..." />*/}
      <button className="form-control btn btn-outline-info" onClick={generarContenido} disabled={loading}>
        {loading ? 'Pensando...' : `Enviar prompt ${type} asociado al tema`}
      </button>

      <div className=''>
        {/* <Markdownkatexnew>
          {response}
        </Markdownkatexnew> */}
        {response?<textarea className="form-control" value={response} rows={8}></textarea>:''}
      </div>
    </div>
  );
};

export default GeminiChat;
